<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="DED" id="_idParaDest-1"><span class="CharOverride-1"><a id="page_v"></a></span><a id="page_v">For Callie</a></p><a id="page_v">
</a></div><a id="page_v">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?7e1ae14a